<template>
  <div id="" class="mainDiv">
    <div class="left-box" :style="examHeight">
      <div class="left-head">考生信息</div>
      <img class="left-avtor" :src="url + userInfo.userPhoto" alt="" />
      <table style="width: 100%" class="myTable">
        <tr>
          <td class="column">考生姓名</td>
          <td class="column">{{ userInfo.fullName }}</td>
        </tr>
        <tr>
          <td class="column">准考证号</td>
          <td class="column">{{ userInfo.admissionCard }}</td>
        </tr>
        <tr>
          <td class="column">身份证号</td>
          <td class="column">{{ userInfo.userCard }}</td>
        </tr>
        <tr>
          <td class="column">登记手机</td>
          <td class="column">{{ userInfo.phone }}</td>
        </tr>
        <tr v-if="userInfo.score">
          <td class="column">当前得分</td> 
          <td class="column">{{ userInfo.score }}</td>
        </tr>
        <tr v-if="userInfo.remainTime">
          <td class="column">剩余考试时间</td>
          <td class="column">{{ userInfo.remainTime | showDate3 }}</td>
        </tr>
        <tr>
          <td class="column">巡考状态</td>
          <td
            class="column"
            style="color: #ff5503"
            v-if="userInfo.tourStatus == 0"
          >
            未巡考
          </td>
          <td
            class="column"
            style="color: #ff5503"
            v-if="userInfo.tourStatus == 1"
          >
            已通过
          </td>
          <td
            class="column"
            style="color: #ff5503"
            v-if="userInfo.tourStatus == 2"
          >
            未通过
          </td>
          <td
            class="column"
            style="color: #ff5503"
            v-if="userInfo.tourStatus == 3"
          >
            巡考中
          </td>
        </tr>
      </table>
    </div>
    <div class="right-box" :style="examHeight">
      <div class="right-head">视频监控</div>
      <div class="colse-btn">
        <el-button type="warning" @click="endTourDialogVisible = true"
          >结束巡考</el-button
        >
      </div>
      <div class="video">
        <img :src="nowPlayImg" alt="" />
      </div>
      <div class="btn-list">
        <el-button type="warning" @click="startWarning">发起警告</el-button>
        <el-button type="primary" @click="screenshot">截取画面</el-button>
      </div>
      <p class="right-text">
        发现异常可先截图以作为审核证据，已截取{{ screenShotNum }}张
      </p>
      <p class="right-text">如发现考生违纪行为可发起警告</p>
      <div class="warning-box">
        <div v-if="isWarning" class="warning-head">
          <div class="warning-left">
            <p class="warning-title">你已向学员发起警告，学员考试已暂停</p>
            <p class="warning-txt">
              警告过程中，对存在严重违纪行为的考生发起警告，该考生考试被暂停，你可以跟考生进行交流，要求考试配合完成巡考，遵守考试纪律，如果考试拒不服从，依然违反考试纪律，你有权终止该考生的考试，并评定成绩无效
            </p>
          </div>
          <div class="warning-right">
            <el-row
              ><el-button type="success" @click="stopWarning"
                >让考生继续考试</el-button
              ></el-row
            >
            <el-button
              type="warning"
              @click="showStopExam"
              style="margin-top: 10px"
              >终止该考生考试</el-button
            >
          </div>
        </div>
        <div class="chat">
          <el-form :inline="true">
            <el-input
              v-model="message"
              placeholder=""
              style="width: 85%; margin-right: 10px"
            ></el-input>
            <el-form-item>
              <el-button type="warning" @click="sendMessage">发送</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="chat-box">
          <div v-for="(item, index) in msgList" :key="index">
            <div class="sender" v-if="item.type === 0">
              <div style="padding: 6px 0">{{ item.name }}</div>
              <div>
                <div class="left_triangle"></div>
                <span> {{ item.message }} </span>
              </div>
            </div>
            <!-- Right -->
            <div class="receiver" v-if="item.type === 1">
              <div style="padding: 6px 0">{{ item.name }}</div>
              <div>
                <div class="right_triangle"></div>
                <span> {{ item.message }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="终止考生考试"
      :visible.sync="showStopExamDialog"
      :before-close="beforeCloseStopExamDialog"
      destroy-on-close
    >
      <el-form>
        <el-form-item label="学生姓名" :label-width="'120px'">
          <p>{{ userInfo.fullName }}</p>
        </el-form-item>
        <el-form-item label="准考证号" :label-width="'120px'">
          <p>{{ userInfo.admissionCard }}</p>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="'120px'">
          <p>{{ userInfo.userCard }}</p>
        </el-form-item>
        <el-form-item label="原因" :label-width="'120px'">
          <el-input
            v-model="stopReason"
            type="textarea"
            autocomplete="off"
            placeholder="请仔细填写取消考试的原因"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择过程性截图" :label-width="'120px'">
          <el-button type="primary" @click="showSelectImage = true"
            >从考试过程截图中选择</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showStopExamDialog = false">取 消</el-button>
        <el-button type="primary" @click="stopExam">确 定</el-button>
      </div>

      <el-dialog
        width="100%"
        title="选择过程性截图"
        :visible.sync="showSelectImage"
        append-to-body
        destroy-on-close
        v-if="showSelectImage"
      >
        <div class="record-info">
          <div class="record-info-left">
            当前已抓拍{{
              screenShotList.length
            }}张考生考试过程中的人脸照片，识别通过{{ passCount }}张，不通过<span
              style="color: red"
              >{{ screenShotList.length - passCount }}</span
            >张
          </div>
          <div class="record-info-right">
            要求识别率：70%/当前识别率：<span style="color: red"
              >{{ passRate }}%</span
            >
          </div>
        </div>
        <div class="record-list">
          <p style="padding: 5px">识别通过（{{ passCount }}）</p>
          <div class="record-img-ul">
            <div
              v-for="(item, index) in screenShotList"
              :key="index"
              class="record-img-li"
              @click="selectProgressImage(item.id)"
            >
              <div class="record-img-li-lv">
                识别率：{{ item.discriminateRate }}%
              </div>
              <img :src="url + item.fileName" alt="" />
              <div class="record-img-li-bottom">
                <div v-if="item.status == 0">正常</div>
                <div v-if="item.status == 1">异常</div>
                <div>{{ item.createTime | showDate }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog
      title="结束巡考"
      :visible.sync="endTourDialogVisible"
      width="30%"
      class="end_tour"
    >
      <el-button @click="endTour(0)">巡考不通过</el-button>
      <el-button type="primary" @click="endTour(1)">巡考通过</el-button>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/invigilate/invigilateList'
import * as api2 from '@/api/exam/exam'
import { formatDate, setHost } from '@/utils/common'

export default {
  name: 'InvigilateDetails',
  data() {
    return {
      examsUsersId: '',
      examinerId: '',
      examHeight: '',
      message: '',
      isWarning: false,
      showStopExamDialog: false,
      showSelectImage: false,
      stopReason: '',
      stopReasonImg: '',
      imgList: [],
      nowPlayImg: '',
      msgList: [],
      userInfo: [],
      host: '',
      screenShotList: [],
      passCount: '',
      endTourDialogVisible: false,
      screenShotNum: 0,
      msgTimer: '',
      count: 0,
      timer: '',
      uid: '',
    }
  },
  computed: {
    passRate: function () {
      const passCount = this.passCount
      const allCount = Number(this.screenShotList.length)
      if (passCount === 0 || allCount === 0) return 0
      const rate = (passCount / allCount).toFixed(4) * 100
      return rate
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }else if(window.location.host == 'fxl.sce.scut.edu.cn'){
        url = 'https://fxl.sce.scut.edu.cn'+ '/zk'
      }
      return url
    },
  },
  filters: {
    // 时间格式化
    showDate(value) {
      let date = new Date(value * 1000)
      return formatDate(date, 'mm:ss')
    },
    // 时间格式化
    showDate3(value) {
      let hour = 0
      let min = 0
      let sec = 0
      hour = Math.floor((value / 60 / 60) % 60)
      min = Math.floor((value / 60) % 60)
      sec = Math.floor(value % 60)
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      return hour + ':' + min + ':' + sec
    },
  },
  methods: {
    //设置主div高度
    setDivHeight() {
      const allHeight = parseInt(document.body.clientHeight)
      // const headHeight = parseInt(this.$refs.head.offsetHeight);
      // const examHeight = allHeight - headHeight
      this.examHeight = 'height:' + allHeight + 'px'
    },
    // 开始巡考
    startInvigilate() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
        examinerId: this.examinerId,
      }
      api.startTouring(reqdata).then(({ data }) => {
        if (data.code == 100000) {
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //获取考试用户的uid
    getByIdWithBLOBs() {
      api2
        .getByIdWithBLOBs3({
          examsUsersId: this.examsUsersId,
        })
        .then(({ data }) => {
          this.uid = data.data.examsUsers.uid
          this.getPhotoFrameList()
        })
    },
    // 获取考试用户的图片帧列表
    getPhotoFrameList() {
      let that = this
      let reqdata = {
        uid: this.uid,
      }
      api.getPhotoFrameList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          if (data.data && data.data.length > 0) {
            that.imgList = data.data
            console.log("用户图片",data.data);
            that.playImg()
          }
        } else {
          that.$message.error(data.msg)
        }
        this.timer = setTimeout(() => {
          // 过一段时间就要重新获取实时画面
          that.getPhotoFrameList()
        }, 15000)
      })
    },
    // 播放图片桢
    playImg() {
      let that = this
      let count = this.count
      setTimeout(() => {
        let url = window.location.protocol + '//' + window.location.host
        if (window.location.host == 'localhost:5001') {
          url = 'http://gz.hnjk.net'
        }
        that.host = url
        if (count < that.imgList.length) {
          that.nowPlayImg = url + that.imgList[count].url
          that.count = count + 1
        } else {
          that.count = 0
          that.nowPlayImg = url + that.imgList[count].url
        }
        that.playImg()
      }, 1000)
    },
    // 获取考生信息
    getExamsUsersById() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api2.getExamsUsersById(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          that.userInfo = data.data
          console.log("获取用户信息",that.userInfo);
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // imgToBase64(url, cb) {
    //   var canvas = document.createElement('canvas'),
    //     ctx = canvas.getContext('2d'),
    //     img = new Image()

    //   img.crossOrigin = 'Anonymous'
    //   img.onload = function () {
    //     canvas.height = img.height
    //     canvas.width = img.width
    //     ctx.drawImage(img, 0, 0)
    //     var dataURL = canvas.toDataURL('image/png')
    //     cb && cb(dataURL)
    //     canvas = null
    //   }
    //   img.src = url
    // },
    getBase64Image(image, callback) {
      var img = new Image()
      img.src = image
      // img.setAttribute('crossOrigin', 'anonymous') //跨域问题,服务器未设置,只能提交到测试环境中测试
      img.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, img.width, img.height)
        var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
        var dataURL = canvas.toDataURL('image/' + ext)
        callback(dataURL)
      }
    },
    base64toFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      })
    },
    //获取文件名
    GetPageName(url) {
      var tmp = new Array()
      tmp = url.split('/') //按照"/"分割
      var pp = tmp[tmp.length - 1] //获取最后一部分，即文件名和参数
      tmp = pp.split('?') //把参数和文件名分割开
      return tmp[0]
    },
    // 截取画面
    screenshot() {
      // this.imgToBase64(this.nowPlayImg,function(res){
      //   console.log(res)
      // })
      // let that = this
      // let reqdata = {
      //   // uid:this.getUId(),
      //   examsUsersId: this.examsUsersId,
      //   fileName: that.GetPageName(that.nowPlayImg),
      // }
      if(this.nowPlayImg && baseURL){
         this.getBase64Image(this.nowPlayImg, (baseURL) => {
        const uploadImgFile = this.base64toFile(baseURL)
        api.screenShot(uploadImgFile, { examsUsersId: this.examsUsersId })
          .then(({ data }) => {
            if (data.code == 100000) {
              this.$message({ message: '截取成功', type: 'success' })
              this.getScreenShotList2()
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      }else{
        this.$message.error("截取图片失败")
      }
     
    },
    // 获取考试过程性截图
    getScreenShotList() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
        type: 0,
        staus: '',
      }
      api.getScreenShotList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.screenShotList = data.data
          console.log(this.screenShotList)
          let passCount = 0
          //计算通过抓拍的张数
          for (let item of data.data) {
            if (item.status == 0) {
              passCount++
            }
          }
          that.passCount = passCount
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //获取截取画面的张数
    getScreenShotList2() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
        type: 1,
        staus: '',
      }
      api.getScreenShotList(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.screenShotNum = data.data.length
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    //结束巡考
    endTour(type) {
      const examsUsersId = this.examsUsersId
      if (type === 0) {
        api.tourFailed({ examsUsersId }).then(({ data }) => {
          if (data.code === 100000) {
            this.endTourDialogVisible = false
            this.$message.success(data.msg)
            this.goBack()
          } else {
            this.$message.error(data.msg)
          }
        })
      } else if (type === 1) {
        api.tourPass({ examsUsersId }).then(({ data }) => {
          if (data.code === 100000) {
            this.endTourDialogVisible = false
            this.$message.success(data.msg)
            this.goBack()
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },
    // 发起警告
    startWarning() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api.startWarning(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.isWarning = true
          // this.getScreenShotList();
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    stopWarning() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
        tourStatus: '0',
      }
      this.$confirm('是否结束本次警告,让考生继续考试?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api.stopWarning(reqdata).then(({ data }) => {
            if (data.code == 100000) {
              this.isWarning = false
            } else {
              this.$message.error(data.msg)
            }
          })
        })
        .catch(() => {})
    },
    beforeCloseStopExamDialog() {
      this.stopReason = ''
      this.stopReasonImg = ''
      this.showStopExamDialog = false
    },
    // 获取聊天消息
    getMessage() {
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
      }
      api.getMessage(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          that.msgList = data.data.messageList
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 发送聊天消息
    sendMessage() {
      if (this.message.trim() === '') {
        this.$message.error('请勿发送空内容')
        this.message = ''
        return
      }
      let that = this
      let reqdata = {
        examsUsersId: this.examsUsersId,
        uid: this.getUId(),
        // messageTime: parseInt(new Date().getTime() / 1000),
        message: this.message,
        type: 0,
      }
      console.log(reqdata)
      api.sendMessage(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.message = ''
          that.getMessage()
        } else {
          that.$message.error(data.msg)
        }
      })
    },
    continueExam() {
      this.$confirm('是否结束警告，让考生继续考试？')
    },
    // 打开终止考试弹窗
    showStopExam() {
      this.showStopExamDialog = true
      let that = this
      this.getScreenShotList()
    },
    // 终止考试
    stopExam() {
      let reqdata = {
        examsUsersId: this.examsUsersId,
        reason: this.stopReason,
        screenShotIds: this.stopReasonImg,
      }
      api.stopExamsUsers(reqdata).then(({ data }) => {
        if (data.code == 100000) {
          this.showStopExamDialog = false
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 在终止考试弹窗里选择过程截图
    selectProgressImage(id) {
      console.log(id)
      this.stopReasonImg = id
      this.$message.success('选择成功')
      this.showSelectImage = false
    },
    goBack() {
      window.history.go(-1)
    },
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  mounted() {
    this.examsUsersId = this.$route.query.exams_users_id
    this.examinerId = this.$route.query.examiner_id
    this.setDivHeight()
    this.startInvigilate()
    this.getByIdWithBLOBs()
    this.getExamsUsersById()
    this.getMessage()
    this.getScreenShotList2()
    this.msgTimer = setInterval(() => {
      this.getMessage()
    }, 30000)
  },
  beforeDestroy() {
    clearInterval(this.msgTimer)
    clearTimeout(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.mainDiv {
  margin: 0;
  padding: 0;
}
.left-box {
  width: 20%;
  float: left;
  overflow-y: auto;
}
.left-head {
  padding: 20px;
  border-left: 6px solid #2f527b;
  background-color: #f6f6f6;
}
.left-avtor {
  width: 135px;
  height: 205px;
  margin: auto;
  display: block;
  margin-top: 20px;
}
.myTable {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
}
.myTable td,
.myTable th {
  border: 1px solid #ededed;
  color: #666;
  height: 40px;
  font-size: 14px;
}
.right-box {
  width: 80%;
  float: left;
  position: relative;
  overflow-y: auto;
}
.right-head {
  padding: 20px;
  border-left: 6px solid #2f527b;
  background-color: #f6f6f6;
}
.colse-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
.video {
  width: 300px;
  margin: auto;
  margin-top: 50px;
}
.video > img {
  width: 100%;
  display: block;
}
.btn-list {
  margin-top: 20px;
  text-align: center;
}
.right-text {
  color: #b1b2b3;
  font-size: 14px;
  text-align: center;
  padding: 3px 0;
}
.warning-box {
  border: 2px solid #fed3ad;
  padding: 10px;
  border-radius: 10px;
  margin-top: 10px;
}
.warning-head {
  display: flex;
  justify-content: left;
}
.warning-left {
  flex: 1;
}
.warning-right {
  padding: 10px;
}
.warning-title {
  font-size: 20px;
  font-weight: 600;
  color: #fe8f2c;
  margin-bottom: 10px;
}
.warning-txt {
  color: #a1a09f;
}
.chat {
  padding: 10px;
  background-color: #f2f2f2;
}
.chat-box {
  padding: 20px 10px;
  padding-bottom: 40px;
}
.clear:after {
  display: block;
  clear: both;
  content: '';
  height: 0;
  visibility: hidden;
}
.chat-style1 {
  // float: left;
  margin-right: 10px;
}
.chat-style2 {
  // float: right;
  margin-right: 10px;
}
.sender {
  clear: both;
}
.sender div:nth-of-type(1) {
  float: left;
}
.sender div:nth-of-type(2) {
  background-color: #7fffd4;
  float: left;
  margin: 0 20px 10px 15px;
  padding: 10px 10px 10px 0;
  border-radius: 7px;
}
.receiver div:first-child img,
.sender div:first-child img {
  width: 50px;
  height: 50px;
}
.receiver {
  clear: both;
}
.receiver div:nth-child(1) {
  float: right;
}
.receiver div:nth-of-type(2) {
  float: right;
  background-color: gold;
  margin: 0 10px 10px 20px;
  padding: 10px 0 10px 10px;
  border-radius: 7px;
}
.left_triangle {
  height: 0;
  width: 0;
  border-width: 8px;
  border-style: solid;
  border-color: transparent #7fffd4 transparent transparent;
  position: relative;
  left: -16px;
  top: 3px;
}
.right_triangle {
  height: 0;
  width: 0;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent transparent gold;
  position: relative;
  right: -16px;
  top: 3px;
}
.record-info {
  display: flex;
  justify-content: space-between;
  border: 2px solid #f6f6f6;
  padding: 10px;
  font-size: 14px;
}
.record-img-ul {
  display: flex;
  flex-wrap: wrap;
}
.record-img-li {
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}
.record-img-li-lv {
  position: absolute;
  top: 5px;
  right: 0px;
  font-size: 12px;
  color: white;
  padding: 3px;
  background-color: rgba(30, 30, 30, 0.7);
}
.record-img-li > img {
  width: 120px;
  height: 90px;
}
.record-img-li-bottom {
  display: flex;
  justify-content: space-between;
  background-color: #58b65a;
  color: white;
  font-size: 12px;
  padding: 5px;
}
.end_tour {
  /deep/ .el-dialog__body {
    display: flex;
    justify-content: center;
  }
}
</style>
